export var PageControlState;
(function (PageControlState) {
    PageControlState["CURRENT"] = "CURRENT";
    PageControlState["DEFAULT"] = "DEFAULT";
    PageControlState["LAST"] = "LAST";
})(PageControlState || (PageControlState = {}));
export var ArrowsControlState;
(function (ArrowsControlState) {
    ArrowsControlState["INACTIVE"] = "INACTIVE";
    ArrowsControlState["ACTIVE"] = "ACTIVE";
})(ArrowsControlState || (ArrowsControlState = {}));
export var PageControlDirectionType;
(function (PageControlDirectionType) {
    PageControlDirectionType["FORTH"] = "FORTH";
    PageControlDirectionType["BACK"] = "BACK";
})(PageControlDirectionType || (PageControlDirectionType = {}));
//# sourceMappingURL=pageControlStates.js.map